export default "__VITE_ASSET__CFHOE5CZ__"